<template>
    <div>
        <VarPopup :class="['create-ai-box-popup', IsMobile ? 'phone-create-ai-box-popup' : '']"
            v-model:show="createAiObj.show" :default-style="true">
            <div :style="{ width: IsMobile ? '100%' : '350px', borderRadius: '10px' }">
                <VarSpace class="create-ai-box-title" justify="center">
                    <VarImage radius="50%" width="20" height="20" :src="$R(createAiObj.data?.Icon)"></VarImage>
                    <span>{{ createAiObj.data?.Title }}</span>
                </VarSpace>

                <div class="create-ai-box">
                    <div class="create-ai-item" align="center" justify="space-between">
                        <span class="title">{{ $t('components.HomeComponent.controller.danjia') }}</span>
                        <span class="price">{{ createAiObj.data?.MinAmount
                            }}-{{createAiObj.data?.MaxAmount}}{{ $t('components.HomeComponent.controller.meiyuan') }}</span>
                    </div>
                    <div class="line"></div>
                    <div class="create-ai-item" align="center" justify="space-between">
                        <span class="title">{{ $t('components.HomeComponent.controller.zdsl') }}</span>
                        <span class="price">{{ createAiObj.data?.UseCount }}/{{ createAiObj.data?.MaxOrderCount
                        }}</span>
                    </div>

                    <div class="select">
                        <VarSelect :placeholder="$t('components.HomeComponent.controller.qxztzcp')"
                            v-model="createAiObj.input_data.ProductId">
                            <VarOption :label="v.Dn" :value="v.Id" v-for="v in createAiObj.input_products">
                                {{ v.Dn }}
                            </VarOption>
                        </VarSelect>
                    </div>

                    <div class="select">
                        <!-- <VarSelect :placeholder="$t('components.HomeComponent.controller.qxzgg')"
                            v-model="createAiObj.input_data.Leverage">
                            <VarOption :label="v" :value="v"
                                v-for="v in GetLeverageList(createAiObj.data?.LeverageList ?? [])">
                                {{ v }}
                            </VarOption>
                        </VarSelect> -->
                        <var-counter 
                            input-text-size="18px"
                            input-width="100%"
                            button-size="36px"
                            style="margin-top: 20px;"
                            :min="createAiObj.data?.MinAmount" 
                            :max="createAiObj.data?.MaxAmount"  
                            v-model="createAiObj.input_data.BuyCost"
                            :step="createAiObj.data?.StepAmount ?? 1" />

                    </div>

                    <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
                        <VarButton style="width: 40%;" class="tz-btn" size="normal" type="primary"
                            @click="ToCreateAiOrder">
                            {{ $t('components.HomeComponent.controller.ljtz') }}
                        </VarButton>
                        <VarButton style="margin-left: 10px;" class="close-btn" size="normal" @click="CloseInvest">
                            {{ $t('components.HomeComponent.controller.quxiao') }}</VarButton>
                    </div>

                </div>
            </div>
        </VarPopup>
        <template v-if="IsMobile">
            <VarRow>
                <VarCol :span="24">
                    <var-swipe class="swipe-example">
                        <var-swipe-item>
                            <img class="swipe-example-image" src="@/assets/images/ai-ui-top.png">
                        </var-swipe-item>
                    </var-swipe>
                </VarCol>
                <VarCol :offset="1" :span="22" justify="center">
                    <VarSpace direction="column">
                        <span style="font-size: 38px;font-weight: bold;">{{ $t('components.HomeComponent.contents.t1')
                            }}</span>
                        <span>{{ $t('components.HomeComponent.contents.t2') }}{{ systemStore.config?.SystemName }}
                            {{ $t('components.HomeComponent.contents.t3') }}</span>
                    </VarSpace>
                </VarCol>
                <VarCol :span="24" justify="center">
                    <span style="margin: 10px 0px; font-size: 20px; margin-top: 30px;">{{
                        $t('components.HomeComponent.contents.t4') }}</span>
                </VarCol>
                <VarCol :span="24" v-for="v in aiObj.list" :key="v.Id" style="margin-bottom: 10px;">
                    <VarCard>
                        <VarRow>
                            <VarCol :span="24" align="center">
                                <VarImage radius="50%" width="50" :src="$R(v.Icon)" />
                                <span>{{ v.Title }}</span>
                            </VarCol>
                            <VarCol>
                                <VarImage :src="$R(v.DetailImg)" />
                            </VarCol>
                            <VarCol :span="24" style="margin-top: 5px;">
                                <VarRow style="width:100%">
                                    <VarCol :span="10" align="start" direction="column">
                                        <span>{{ $t('components.HomeComponent.contents.jiage') }}</span>
                                        <span>${{ Tools.TruncateDecimal(v.MinAmount ?? 0, 2) }}-${{
                                            Tools.TruncateDecimal(v.MaxAmount
                                                ??
                                                0,
                                                2) }}</span>
                                    </VarCol>
                                    <VarCol :span="2">
                                        <VarDivider :vertical="true" />
                                    </VarCol>
                                    <VarCol :span="12" align="end" direction="column">
                                        <span>{{ $t('components.HomeComponent.contents.lirun') }}</span>
                                        <span>${{ Tools.TruncateDecimal(v.MinAmount! * v.MinProfitPercentage!, 2) }}-${{
                                            Tools.TruncateDecimal(v.MaxAmount! *
                                                v.MaxProfitPercentage!, 2) }}</span>
                                    </VarCol>
                                </VarRow>
                            </VarCol>
                            <VarCol :span="24">
                                <VarDivider />
                            </VarCol>
                            <VarCol :span="24">
                                <VarRow style="width: 100%;">
                                    <VarCol :span="12" justify="start">
                                        <span>{{ $t('components.HomeComponent.contents.mrzdxdl') }}</span>
                                    </VarCol>
                                    <VarCol :span="12" justify="end">
                                        <span>{{ v.MaxOrderCount }}</span>
                                    </VarCol>
                                </VarRow>
                            </VarCol>
                            <VarCol :span="24">
                                <VarDivider />
                            </VarCol>


                            <VarCol :span="24" style="width: 100%; margin-top: 20px;" justify="center">
                                <VarButton type="primary" style="width: 60%;" @click="ShowInvest(v)">
                                    {{ $t('components.HomeComponent.contents.ljtz') }}</VarButton>
                                <!-- <VarButton type="primary" style="width: 40%;">查看详情</VarButton> -->
                            </VarCol>

                        </VarRow>
                    </VarCard>
                </VarCol>
            </VarRow>
        </template>
        <template v-else>
            <div class="pc-home-body">
                <div class="pc-home-content">
                    <div class="pc-row">
                        <div class="pc-lie t1" style="justify-content: center;">
                            <span style="font-size: 64px;font-weight: bold;">{{
                                $t('components.HomeComponent.contents.t1') }}</span>
                            <span style="color: rgba(255,255,255,0.6);">{{ $t('components.HomeComponent.contents.t2')
                            }}{{
                                    systemStore.config?.SystemName }}
                                {{ $t('components.HomeComponent.contents.t3') }}</span>
                        </div>
                        <div class="pc-row">
                            <img class="swipe-example-image" src="@/assets/images/ai-ui-top.png">
                        </div>
                    </div>

                    <div class="grid-box">
                        <h4 class="title">{{ $t('components.HomeComponent.contents.t5') }} {{
                            systemStore.config?.SystemName }}？</h4>
                        <div class="grid-content">
                            <div class="grid-item" v-for="v in xzList">
                                <div class="pc-row" style="align-items: center;">
                                    <img style="border-radius: 50%;" :src="v.icon" width="32px" height="32px">
                                    <span style="font-size: 18px;">
                                        {{ v.title }}
                                    </span>
                                </div>
                                <span v-if="v.desc" style="font-size: 14px; opacity: 0.4; margin-top: 10px;">{{ v.desc
                                    }}</span>
                            </div>
                        </div>
                    </div>



                    <div class="grid-box">
                        <h4 class="title">{{ $t('components.HomeComponent.contents.t6') }}</h4>
                        <div class="grid-content">
                            <div class="grid-item" v-for="v in aqhgList">
                                <div class="pc-row" style="align-items: center;">
                                    <img style="border-radius: 50%;" :src="v.icon" width="32px" height="32px">
                                    <span style="font-size: 18px;">
                                        {{ v.title }}
                                    </span>
                                </div>
                                <span v-if="v.desc" style="font-size: 14px; opacity: 0.4; margin-top: 10px;">{{ v.desc
                                    }}</span>
                            </div>
                        </div>
                    </div>


                    <div class="grid-box">
                        <h4 class="title">{{ $t('components.HomeComponent.contents.t4') }}</h4>
                        <div class="grid-content">
                            <div class="grid-item" v-for="v in aiObj.list" :key="v.Id" style="font-size: 12px;">
                                <VarRow>
                                    <VarCol :span="24" align="center">
                                        <VarImage radius="50%" width="50" :src="$R(v.Icon)" />
                                        <span style="font-size: 18px; margin-left: 5px;">{{ v.Title }}</span>
                                    </VarCol>
                                    <VarCol>
                                        <VarImage :src="$R(v.DetailImg)" />
                                    </VarCol>
                                    <VarCol :span="24" style="margin-top: 5px;">
                                        <VarRow style="width:100%">
                                            <VarCol :span="10" align="start" direction="column">
                                                <span>{{ $t('components.HomeComponent.contents.jiage') }}</span>
                                                <span>${{ Tools.TruncateDecimal(v.MinAmount ?? 0, 2) }}-${{
                                                    Tools.TruncateDecimal(v.MaxAmount
                                                        ??
                                                        0,
                                                        2) }}</span>
                                            </VarCol>
                                            <VarCol :span="2">
                                                <VarDivider :vertical="true" />
                                            </VarCol>
                                            <VarCol :span="12" align="end" direction="column">
                                                <span>{{ $t('components.HomeComponent.contents.lirun') }}</span>
                                                <span>${{ Tools.TruncateDecimal(v.MinAmount! * v.MinProfitPercentage!,
                                                    2)
                                                }}-${{ Tools.TruncateDecimal(v.MaxAmount! * v.MaxProfitPercentage!,
                                                        2) }}</span>
                                            </VarCol>
                                        </VarRow>
                                    </VarCol>
                                    <VarCol :span="24">
                                        <VarDivider />
                                    </VarCol>
                                    <VarCol :span="24">
                                        <VarRow style="width: 100%;">
                                            <VarCol :span="12" justify="start">
                                                <span>{{ $t('components.HomeComponent.contents.mrzdxdl') }}</span>
                                            </VarCol>
                                            <VarCol :span="12" justify="end">
                                                <span>{{ v.MaxOrderCount }}</span>
                                            </VarCol>
                                        </VarRow>
                                    </VarCol>
                                    <VarCol :span="24">
                                        <VarDivider />
                                    </VarCol>


                                    <VarCol :span="24" style="width: 100%; margin-top: 20px;" justify="center">
                                        <VarButton type="primary" style="width: 60%;" @click="ShowInvest(v)">{{
                                            $t('components.HomeComponent.contents.ljtz') }}
                                        </VarButton>
                                        <!-- <VarButton type="primary" style="width: 40%;">查看详情</VarButton> -->
                                    </VarCol>

                                </VarRow>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </template>
    </div>
</template>

<script setup lang="tsx">
import { useLocale } from '@/hooks/useLocale';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useUserStore } from '@/store/UserStore';
import { fetchGetAiProductListAsync } from '@/typescript/Services/Api/AiProduct';
import { fetchCreateAiOrderForUserAsync, fetchGetMyAiOrderLimitFromAiProducIdAsync, InputCreateAiOrder } from '@/typescript/Services/Api/OrderApi';
import { fetchGetProductListForUserAsync } from '@/typescript/Services/Api/ProductApi';
import { request } from '@/typescript/Services/request';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';
const IsMobile = inject<boolean>("IsMobile");
const local = useLocale();
const systemStore = useSystemConfigStore();
const userStore = useUserStore();
const aiObj = ref<{
    show: boolean;
    list: (DB.AiProduct & { UseCount: number })[],
    loading: boolean
}>({
    show: false,
    loading: true,
    list: []
});

const createAiObj = ref<{
    show: boolean,
    data?: DB.AiProduct & {
        UseCount: number
    },
    input_products: DB.Product[],
    input_data: InputCreateAiOrder
}>({
    show: false,
    input_products: [],
    input_data: {
        BuyCost: 1,
        ProductId: 0,
        AiProductId: 0
    }
});

const xzList = ref<{
    title: string,
    icon: string,
    desc: string
}[]>([
    {
        title: local.t('components.HomeComponent.xzlist.t1'),
        desc: local.t('components.HomeComponent.xzlist.t1_desc'),
        icon: require("@/assets/images/home_icons/1.png"),
    },
    {
        title: local.t('components.HomeComponent.xzlist.t2'),
        desc: local.t('components.HomeComponent.xzlist.t2_desc'),
        icon: require("@/assets/images/home_icons/2.png"),
    },
    {
        title: local.t('components.HomeComponent.xzlist.t3'),
        desc: local.t('components.HomeComponent.xzlist.t3_desc'),
        icon: require("@/assets/images/home_icons/3.png")
    },
    {
        title: local.t('components.HomeComponent.xzlist.t4'),
        desc: local.t('components.HomeComponent.xzlist.t4_desc'),
        icon: require("@/assets/images/home_icons/4.png"),

    },
    {
        title: local.t('components.HomeComponent.xzlist.t5'),
        desc: local.t('components.HomeComponent.xzlist.t5_desc'),
        icon: require("@/assets/images/home_icons/5.png"),

    },
    {
        title: local.t('components.HomeComponent.xzlist.t6'),
        desc: local.t('components.HomeComponent.xzlist.t6_desc'),
        icon: require("@/assets/images/home_icons/6.png"),

    },

]);

const aqhgList = ref<{
    title: string,
    icon: string,
    desc: string
}[]>([
    {
        title: local.t('components.HomeComponent.aqhglist.t1'),
        icon: require("@/assets/images/home_icons/7.png"),
        desc: ""
    },
    {
        title: local.t('components.HomeComponent.aqhglist.t2'),
        icon: require("@/assets/images/home_icons/8.png"),
        desc: ""
    },
    {
        title: local.t('components.HomeComponent.aqhglist.t3'),
        icon: require("@/assets/images/home_icons/9.png"),
        desc: ""
    }

]);


watch(() => userStore.getUser.Uid, (_n, _o) => {
    GetAiProductList();
    GetProductListForUser();
}, {
    immediate: true
});

watch(() => createAiObj.value.input_data.BuyCost, (_n, _o) => {
    
    if (_n < createAiObj.value.data!.MinAmount!) {
        createAiObj.value.input_data.BuyCost = createAiObj.value.data!.MinAmount!;
    }
    else if (_n > createAiObj.value.data!.MaxAmount!) {
        createAiObj.value.input_data.BuyCost = createAiObj.value.data!.MaxAmount!;
    }
});


function GetLeverageList(v: string | number[]) {
    if (typeof v == "string")
        v = JSON.parse(v);
    return v;
}

function GetAiProductList() {
    aiObj.value.loading = true;
    fetchGetAiProductListAsync().then(resp => {
        if (resp.CheckIsOk()) {
            aiObj.value.list = resp.data!;
        }
        aiObj.value.loading = false;
    });
}

/**
 * 显示投资窗口
 */
function ShowInvest(aiProduct: DB.AiProduct & {
    UseCount: number
}) {
    createAiObj.value.data = aiProduct;
    createAiObj.value.input_data.AiProductId = aiProduct.Id!;

    //处理下金额
    createAiObj.value.input_data.BuyCost = aiProduct.MinAmount ?? 1;

    createAiObj.value.show = true;
    UpdateProductUseCount(aiProduct);
}

function UpdateProductUseCount(aiProduct: DB.AiProduct & {
    UseCount: number
}) {
    GetMyAiOrderLimitFromAiProducId(aiProduct).then(useCount => {
        aiProduct.UseCount = useCount;
    });
}

/**
 * 获取我的AI订单已经使用的限额数量
 * @param aiProduct 
 */
async function GetMyAiOrderLimitFromAiProducId(aiProduct: DB.AiProduct) {
    const resp = await fetchGetMyAiOrderLimitFromAiProducIdAsync(aiProduct.Id);
    if (resp.CheckIsOk())
        return resp.data!.useCount;
    return 0;
}

/**
 * 创建AI订单
 */
function ToCreateAiOrder() {
    //进行下单提交
    fetchCreateAiOrderForUserAsync(createAiObj.value.input_data).then(resp => {
        if (resp.CheckIsOk()) {
            Tools.AlertSuccess("AI task has been submitted!");
            CloseInvest();
        }
    });
}


/**
 * 关闭投资窗口
 */
function CloseInvest() {
    createAiObj.value.show = false;
}

function GetProductListForUser() {
    fetchGetProductListForUserAsync(true).then(resp => {
        if (resp.CheckIsOk()) {
            const list = resp.data!;
            createAiObj.value.input_products = list;
            createAiObj.value.input_data.ProductId = list[0].Id!;
        }
    })
}



</script>
<style>
.create-ai-box-popup {
    border-radius: 20px;
    padding: 20px !important;
}

.phone-create-ai-box-popup {
    width: 80%;
}
</style>
<style lang="scss" scoped>
.swipe-example {
    width: 100%;

    .swipe-example-image {
        width: 100%;
        object-fit: cover;
    }
}





.pc-home-body {
    display: flex;
    justify-content: center;
    width: 100%;

    .pc-home-content {
        display: flex;
        flex-direction: column;
        width: 80%;

        .pc-row {
            display: flex;
            flex-wrap: nowrap;

            img {
                margin-right: 5px;
            }
        }

        .pc-lie {
            display: flex;
            flex-direction: column;
        }

        .grid-box {
            display: flex;
            justify-content: center;
            flex-direction: column;

            .title {
                text-align: center;
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                line-height: 31px;
            }

            .grid-content {
                display: flex;
                flex-wrap: wrap;

                .grid-item {
                    display: flex;
                    justify-content: center;
                    // align-items: center;
                    padding: 24px;
                    box-sizing: border-box;
                    flex-direction: column;
                    margin: 10px;
                    width: calc(100% / 3 - 20px);
                    border-radius: 6px;
                    background: linear-gradient(102deg, rgba(5, 160, 217, 0.55) 0%, rgba(5, 160, 217, 0.25) 100%);
                }
            }
        }
    }
}
</style>